import { flow, types as t } from 'mobx-state-tree';

import smsApi from 'shared/api/sms';
import { IGetDataLvl1Params, TParamsLvl3 } from 'shared/api/sms/types';
import { fetchCountriesDataLvl2 } from 'shared/api/shared';
import { IFetchCountriesLvl2Params } from 'shared/api/shared/types';

export const OptionProviderM = t.model('OptionProviderM', {
  addr_sri: t.maybe(t.string),
  sri_map_version: t.maybe(t.string),
  src_subaddr: t.maybe(t.string),
  smpp_tag_max_attempts: t.maybe(t.union(t.number, t.string)),
  gt_special_flag: t.maybe(t.union(t.number, t.string)),
  operation_code_tag: t.maybe(t.union(t.number, t.string)),
  scts: t.maybe(t.union(t.number, t.string)),
  smsc: t.maybe(t.union(t.number, t.string)),
  silent: t.maybe(t.union(t.boolean, t.number, t.string)),
  s_numeric: t.maybe(t.union(t.boolean, t.number, t.string)),
  s_short: t.maybe(t.union(t.boolean, t.number, t.string)),
  s_alpha: t.maybe(t.union(t.boolean, t.number, t.string)),
  s_gt: t.maybe(t.union(t.boolean, t.number, t.string)),
  s_gtp: t.maybe(t.union(t.boolean, t.number, t.string)),
  s_gtd: t.maybe(t.union(t.boolean, t.number, t.string)),
  gt_id: t.maybe(t.union(t.string, t.number)),
  fsm_gt_id: t.maybe(t.union(t.string, t.number)),
  sri_gt: t.maybe(t.union(t.string, t.array(t.string))),
  gt_ids: t.maybe(t.array(t.union(t.string, t.number))),
  sri_gts: t.maybe(t.array(t.union(t.string, t.number))),
  fsm_gts: t.maybe(t.array(t.union(t.string, t.number))),
  sri_source_sccps: t.maybe(t.array(t.union(t.string, t.number))),
  fsm_source_sccps: t.maybe(t.array(t.union(t.string, t.number))),
  fsm_gt_ids: t.maybe(t.array(t.union(t.string, t.number))),
  sri_sccp_cd_add_ssn: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  sri_sccp_cd_add_tt: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  sri_sccp_cd_add_sri: t.maybe(t.union(t.number, t.string)),
  sri_sccp_carrier: t.maybe(t.union(t.string, t.number)),
  // New SRI CG and MTP routing params from backend
  sri_sccp_cg_add_ssn: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  sri_sccp_cg_add_tt: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  sri_sccp_cg_add_ni: t.maybe(t.union(t.number, t.string)),
  sri_opc: t.maybe(t.union(t.string, t.number)),
  sri_dpc: t.maybe(t.union(t.string, t.number)),
  fsm_sccp_carrier: t.maybe(t.union(t.string, t.number)),
  fsm_map_version: t.maybe(t.union(t.string, t.number)),
  fsm_sccp_cg_add_ssn: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  fsm_sccp_cg_add_tt: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  fsm_sccp_cg_add_ni: t.maybe(t.union(t.number, t.string)),
  fsm_opc: t.maybe(t.union(t.string, t.number)),
  fsm_dpc: t.maybe(t.union(t.string, t.number)),
  fsm_sccp_cd_add_ssn: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  fsm_sccp_cd_add_tt: t.maybe(t.union(t.number, t.string, t.array(t.number))),
  fsm_sccp_cd_add_gt: t.maybeNull(t.maybe(t.union(t.string, t.number))),
  fsm_sccp_cd_imsi: t.maybeNull(t.maybe(t.union(t.string, t.number))),
  fsm_timezone_gmt: t.maybeNull(t.union(t.string, t.number)),
  fsm_timestamp: t.maybe(t.union(t.string, t.number)),
  fsm_timestamp_type: t.maybe(t.union(t.string, t.number)),
  // Misc
  operators: t.maybe(t.array(t.union(t.number, t.string))),
  tested_by: t.maybe(t.union(t.number, t.string)),
  send_from_user_id: t.maybe(
    t.union(t.array(t.union(t.number, t.string)), t.number, t.string),
  ),

  ported: t.maybe(t.union(t.boolean, t.number, t.string)),
  sri_based_dlr: t.maybe(t.union(t.boolean, t.number, t.string)),
});

export const SmsItemLvl1 = t.model('SmsItemLvl1', {
  a: t.optional(t.boolean, false),
  c: t.optional(t.boolean, false),
  f: t.optional(t.boolean, false),
  created: t.maybeNull(t.string),
  id: t.number,
  n: t.optional(t.boolean, false),
  p: t.optional(t.boolean, false),
  provider: t.maybeNull(t.string),
  s: t.optional(t.boolean, false),
  successOnly: t.optional(t.boolean, false),
  pending: t.optional(t.boolean, false),
  count: t.optional(t.number, 0),
  progress: t.maybe(t.number),
  options: OptionProviderM,
  countries_count: t.optional(t.number, 0),
  mass: t.optional(t.maybeNull(t.boolean), false),
  sent_by: t.maybeNull(t.string),
  created_date: t.maybeNull(t.string),
  done_date: t.maybeNull(t.string),
  stop_date: t.maybeNull(t.string),
  pause_date: t.maybeNull(t.string),
  status: t.optional(t.maybeNull(t.number), 0),
  operators_count: t.number,
  gt_count: t.optional(t.number, 0),
  user_count: t.number,
  events_sent: t.union(t.number, t.string),
  events_delivered: t.union(t.number, t.string),
  user_name: t.maybeNull(t.union(t.string, t.number)),
  success_operators: t.union(t.number, t.string),
  smsc: t.maybe(t.union(t.number, t.string)),
  send_mode: t.maybe(t.string),
});

export const SmsResultsModel = t
  .model('SmsResultsModel', {
    refreshSecondLevelData: t.boolean,
    refreshThirdLevelData: t.boolean,
    dataLvl1: t.array(SmsItemLvl1),
    totalLvl1: t.number,
    areAllMessageDetailsVisible: t.boolean,
    smscValue: t.string,
    countriesLvl2: t.maybeNull(t.frozen()),
    isLoadingCountriesLvl2: t.boolean,
  })
  .actions(self => ({
    setSuccessStatus(i: number, status: boolean) {
      self.dataLvl1[i].successOnly = status;
    },
    getDataLvl1: flow(function* getDataLvl1(params: IGetDataLvl1Params) {
      const { items, total } = yield smsApi.fetchDataLvl1(params);

      /* Backend may return items as an object keyed by id or as an array;
      normalize to array
       */
      const normalizedItems = Array.isArray(items) ? items : Object.values(items || {});
      self.dataLvl1 = normalizedItems as any;
      self.totalLvl1 = total;
    }),
    setRefreshSecondLevelData(status: boolean) {
      self.refreshSecondLevelData = status;
    },
    getResultsLvl2: flow(function* getDataLvl2(testID, params) {
      return yield smsApi.fetchDataLvl2(testID, params);
    }),
    setCountriesLvl2Loading(status: boolean) {
      self.isLoadingCountriesLvl2 = status;
    },
    setCountriesLvl2Data(payload: any) {
      self.countriesLvl2 = payload;
    },

    fetchCountriesDataLvl2: flow(function* (
      extId: number,
      params: IFetchCountriesLvl2Params,
    ) {
      self.isLoadingCountriesLvl2 = true;
      try {
        const data = yield fetchCountriesDataLvl2(extId, params || ({} as any));
        self.countriesLvl2 = data || null;
        return data;
      } catch (e) {
        // error handled in API helper
        return null;
      } finally {
        self.isLoadingCountriesLvl2 = false;
      }
    }),
    getResultsLvl3: flow(function* (
      testID: number,
      operatorID: number,
      params: TParamsLvl3,
    ) {
      return yield smsApi.fetchDataLvl3(testID, operatorID, params);
    }),
    setRefreshThirdLevelData(status: boolean) {
      self.refreshThirdLevelData = status;
    },
    setAllMessageDetailsVisibility(status: boolean) {
      self.areAllMessageDetailsVisible = status;
    },
    exportResults: flow(function* (id) {
      return yield smsApi.exportDataSmsResults(id);
    }),
    setSmscValue(value: string) {
      self.smscValue = value;
    },
  }));
